import questionIcon from '@raison/static/icons/question-line.svg';
import React from 'react';
import {styles} from '../../../Utilities/defineStyles';
import {InlineSvg} from '../../index';
import {FieldLabelProps} from './FieldLabel.types';

const cls = styles({
    label: '~Field__label',
    iconBox: '~Field__labelIconBox',
    subtext: '~Field__labelSubtext',
});

export function FieldLabel({children: text, subtext, hint, icon}: FieldLabelProps) {
    return (
        <div className='block'>
            <div className={cls.label}>
                {text}
                {hint && <span className='text-neutral-60'>{hint}</span>}
                {icon && (
                    <div className={cls.iconBox} onClick={icon.onClick}>
                        <InlineSvg src={icon.svg} className='h-3 w-3' />
                    </div>
                )}
            </div>
            <div className={cls.subtext}>{subtext}</div>
        </div>
    );
}

FieldLabel.displayName = '~FieldLabel';

type FiledLabelWithInfoProps = Omit<FieldLabelProps, 'icon'> & {
    onInfoClick: () => void;
};

export function FieldLabelWithInfo({onInfoClick, ...props}: FiledLabelWithInfoProps) {
    return FieldLabel({...props, icon: {svg: questionIcon, onClick: onInfoClick}});
}

FieldLabelWithInfo.displayName = 'FieldLabelWithInfo';
